import { Plus } from 'lucide-react'
import { Small } from '@/components/sv/typographies'
import { Separator } from '@/components/ui/separator'
import { gql } from '@/lib/graphql/gql'
import { useIdCompany, useSuspenseQuery } from '@/lib/hooks'
import type {
  ResourceTypesQuery,
  ResourceTypesQueryVariables,
} from '@/routes/static-sites/create-static-site/form/sections/overview/estimation.types.gen'
import type { ReactElement } from 'react'

export const RESOURCE_TYPES = gql`
  query ResourceTypes($idCompany: String!) {
    company(id: $idCompany) {
      id
      sevallaBilling {
        id
        taxPercent
      }
      bandwidthResourceType {
        id
        name
        price {
          unitNetPrice
        }
      }
    }
  }
`

export const Estimation = (): ReactElement => {
  const { idCompany } = useIdCompany()
  const { data } = useSuspenseQuery<
    ResourceTypesQuery,
    ResourceTypesQueryVariables
  >(RESOURCE_TYPES, {
    variables: { idCompany },
  })

  const taxPercent = data?.company?.sevallaBilling?.taxPercent ?? 0
  const bandwidthPrice = (0.1 * (taxPercent / 100 + 1)).toFixed(3)
  const buildPrice = (0.05 * (taxPercent / 100 + 1)).toFixed(3)

  return (
    <div className="flex flex-col gap-3">
      <Small>100 GB free bandwidth / month / company</Small>
      <Small>600 free build minutes / month / company</Small>
      <Separator />
      <Small className="font-bold">Overage fees:</Small>
      <div className="flex items-center justify-between">
        <Small className="flex items-center gap-1">
          <Plus className="size-3" /> Bandwidth
        </Small>
        <Small>${bandwidthPrice} / GB</Small>
      </div>
      <div className="flex items-center justify-between">
        <Small className="flex items-center gap-1">
          <Plus className="size-3" /> Build
        </Small>
        <Small>${buildPrice} / minute</Small>
      </div>
    </div>
  )
}
